module.exports = __webpack_public_path__ + "img/checkbox-1.5aa885a6.svg";